export default "__VITE_ASSET__DvPhqD4t__"